// Combined Journey Catalogue — Worldway × A&K
export type { Journey, JourneyDay } from './journeyData';
export { JOURNEY_DATA as AFRICA_JOURNEYS } from './journeyData';
export { ASIA_JOURNEYS } from './journeyData2';
export { EUROPE_JOURNEYS } from './journeyData3';
export { LATAM_POLAR_OCEANIA_JOURNEYS } from './journeyData4';
export { NAMERICA_MIDEAST_JOURNEYS } from './journeyData5';
export { JOURNEYS_BATCH6 } from './journeyData6';
export { JOURNEYS_BATCH7 } from './journeyData7';
export { JOURNEYS_BATCH8 } from './journeyData8';
export { JOURNEYS_BATCH9 } from './journeyData9';
export { JOURNEYS_BATCH10 } from './journeyData10';
export { JOURNEYS_BATCH11 } from './journeyData11';
export { JOURNEYS_BATCH12 } from './journeyData12';
export { JOURNEYS_BATCH13 } from './journeyData13';
export { JOURNEYS_BATCH14 } from './journeyData14';
export { JOURNEYS_BATCH15 } from './journeyData15';
export { JOURNEYS_BATCH16 } from './journeyData16';
export { JOURNEYS_BATCH17 } from './journeyData17';
export { JOURNEYS_BATCH18 } from './journeyData18';
export { JOURNEYS_BATCH19 } from './journeyData19';
export { JOURNEYS_BATCH20 } from './journeyData20';
export { JOURNEYS_BATCH21 } from './journeyData21';
export { JOURNEYS_BATCH21_B } from './journeyData21b';
export { JOURNEYS_BATCH22 } from './journeyData22';
export { JOURNEYS_BATCH23 } from './journeyData23';

import { JOURNEY_DATA as AFRICA_JOURNEYS } from './journeyData';
import type { Journey, JourneyDay } from './journeyData';
import { ASIA_JOURNEYS } from './journeyData2';
import { EUROPE_JOURNEYS } from './journeyData3';
import { LATAM_POLAR_OCEANIA_JOURNEYS } from './journeyData4';
import { NAMERICA_MIDEAST_JOURNEYS } from './journeyData5';
import { JOURNEYS_BATCH6 } from './journeyData6';
import { JOURNEYS_BATCH7 } from './journeyData7';
import { JOURNEYS_BATCH8 } from './journeyData8';
import { JOURNEYS_BATCH9 } from './journeyData9';
import { JOURNEYS_BATCH10 } from './journeyData10';
import { JOURNEYS_BATCH11 } from './journeyData11';
import { JOURNEYS_BATCH12 } from './journeyData12';
import { JOURNEYS_BATCH13 } from './journeyData13';
import { JOURNEYS_BATCH14 } from './journeyData14';
import { JOURNEYS_BATCH15 } from './journeyData15';
import { JOURNEYS_BATCH16 } from './journeyData16';
import { JOURNEYS_BATCH17 } from './journeyData17';
import { JOURNEYS_BATCH18 } from './journeyData18';
import { JOURNEYS_BATCH19 } from './journeyData19';
import { JOURNEYS_BATCH20 } from './journeyData20';
import { JOURNEYS_BATCH21 } from './journeyData21';
import { JOURNEYS_BATCH21_B } from './journeyData21b';
import { JOURNEYS_BATCH22 } from './journeyData22';
import { JOURNEYS_BATCH23 } from './journeyData23';

export const ALL_JOURNEYS = [
  ...AFRICA_JOURNEYS,
  ...ASIA_JOURNEYS,
  ...EUROPE_JOURNEYS,
  ...LATAM_POLAR_OCEANIA_JOURNEYS,
  ...NAMERICA_MIDEAST_JOURNEYS,
  ...JOURNEYS_BATCH6,
  ...JOURNEYS_BATCH7,
  ...JOURNEYS_BATCH8,
  ...JOURNEYS_BATCH9,
  ...JOURNEYS_BATCH10,
  ...JOURNEYS_BATCH11,
  ...JOURNEYS_BATCH12,
  ...JOURNEYS_BATCH13,
  ...JOURNEYS_BATCH14,
  ...JOURNEYS_BATCH15,
  ...JOURNEYS_BATCH16,
  ...JOURNEYS_BATCH17,
  ...JOURNEYS_BATCH18,
  ...JOURNEYS_BATCH19,
  ...JOURNEYS_BATCH20,
  ...JOURNEYS_BATCH21,
  ...JOURNEYS_BATCH21_B,
  ...JOURNEYS_BATCH22,
  ...JOURNEYS_BATCH23,
];

export function getJourneyBySlug(slug: string) {
  return ALL_JOURNEYS.find((j) => j.slug === slug) ?? null;
}
